import { dmpLogo, dmxLogo, dhLogo, dsdLogo, dcdLogo } from "../assets/images";
import {
  privacyPolicyLink,
  copyrightLink,
  feedbackLink,
  dmpHelpLink,
  dmxHelpLink,
  termsOfUseLink,
  dhHelpLink,
  disclaimerLink,
  manageCookiesText,
} from "./constants";

export const products = {
  default: {
    theme: "dmp",
    productName: "dmp",
    isMobile: false,
    title: "Sign in",
    header: {},
    footer: {},
    groupLogin: false,
    showLinks: false,
  },
  "discover.medical.dmp.eeds": {
    theme: "dmp",
    productName: "dmp",
    isMobile: false,
    resetPasswordUrl: "dmp",
    forgotPassword: true,
    title: "Sign in to DynaMed",
    header: { logo: { src: dmpLogo, alt: "DynaMed" } },
    footer: {
      links: [
        { url: "https://dynamed.com/home", text: "About DynaMed" },
        { url: dmpHelpLink, text: "Help" },
        { url: feedbackLink, text: "Feedback" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
        { url: "", text: manageCookiesText, cookiesLink: true },
      ],
      social: [
        { url: "https://twitter.com/dynamedplus", name: "twitter" },
        {
          url: "https://www.linkedin.com/showcase/dynamed-plus",
          name: "linkedin",
        },
      ],
    },
    groupLogin: true,
    showLinks: true,
  },
  "platform.medical.dmpgateway": {
    theme: "dmp",
    productName: "dmp",
    isMobile: false,
    resetPasswordUrl: "dmp",
    forgotPassword: true,
    title: "Sign in to DynaMed",
    header: { logo: { src: dmpLogo, alt: "DynaMed" } },
    footer: {
      links: [
        { url: "https://dynamed.com/home", text: "About DynaMed" },
        { url: dmpHelpLink, text: "Help" },
        { url: feedbackLink, text: "Feedback" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
        { url: "", text: manageCookiesText, cookiesLink: true },
      ],
      social: [
        { url: "https://twitter.com/dynamedplus", name: "twitter" },
        {
          url: "https://www.linkedin.com/showcase/dynamed-plus",
          name: "linkedin",
        },
      ],
    },
    groupLogin: true,
    showLinks: true,
  },
  "platform.medical.dmxgateway": {
    theme: "dmx",
    productName: "dmx",
    isMobile: false,
    resetPasswordUrl: "dmx",
    forgotPassword: true,
    title: "Sign in to DynaMedex",
    header: { logo: { src: dmxLogo, alt: "DynaMedex" } },
    footer: {
      links: [
        { url: "https://www.ebsco.com/clinical-decisions/dynamed-solutions/dynamed-micromedex-with-watson", text: "About" },
        { url: dmxHelpLink, text: "Help" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
        { url: "", text: manageCookiesText, cookiesLink: true },
      ],
    },
    groupLogin: true,
  },
  "platform.medical.dmx-mobile-client": {
    theme: "dmx",
    productName: "dmx",
    isMobile: true,
    resetPasswordUrl: "dmx",
    forgotPassword: true,
    forgotPasswordReturnUrl: "https://www.dynamedex.com/",
    title: "Sign in to DynaMedex",
    header: { logo: { src: dmxLogo, alt: "DynaMedex" } },
    footer: {
      links: [
        { url: "https://www.ebsco.com/clinical-decisions/dynamed-solutions/dynamed-micromedex-with-watson", text: "About" },
        { url: dmxHelpLink, text: "Help" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
      ],
    },
    groupLogin: true,
  },
  "platform.medical.dmp-mobile-client": {
    theme: "dmp",
    productName: "dmp",
    isMobile: true,
    resetPasswordUrl: "dmp",
    forgotPassword: true,
    forgotPasswordReturnUrl: "https://www.dynamed.com/",
    title: "Sign in to DynaMed",
    header: { logo: { src: dmpLogo, alt: "DynaMed" } },
    footer: {
      links: [
        { url: "https://dynamed.com/home", text: "About DynaMed" },
        { url: dmpHelpLink, text: "Help" },
        { url: feedbackLink, text: "Feedback" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
      ],
    },
    groupLogin: true,
  },
  "platform.medical.dh-mobile-client": {
    theme: "dhe",
    productName: "dh",
    isMobile: true,
    resetPasswordUrl: "dh",
    forgotPassword: true,
    forgotPasswordReturnUrl: "https://www.dynahealth.com/",
    title: "Sign in to Dynamic Health",
    header: { logo: { src: dhLogo, alt: "Dynamic Health" } },
    footer: {
      links: [
        {
          url: "https://www.ebsco.com/health-care/products/dynamic-health",
          text: "About Dynamic Health",
        },
        { url: dhHelpLink, text: "Help" },
        { url: disclaimerLink, text: "Disclaimer" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
      ],
    },
    groupLogin: true,
  },
  "platform.medical.dhgateway": {
    theme: "dhe",
    productName: "dh",
    isMobile: false,
    resetPasswordUrl: "dh",
    forgotPassword: true,
    title: "Sign in to Dynamic Health",
    header: {
      logo: { src: dhLogo, alt: "Dynamic Health" },
      inverted: true,
    },
    footer: {
      links: [
        {
          url: "https://www.ebsco.com/health-care/products/dynamic-health",
          text: "About Dynamic Health",
        },
        { url: dhHelpLink, text: "Help" },
        { url: disclaimerLink, text: "Disclaimer" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
        { url: "", text: manageCookiesText, cookiesLink: true },
      ],
    },
    groupLogin: true,
  },
  "dynamed.shared.decisions": {
    theme: "dsd",
    productName: "dcd",
    isMobile: false,
    resetPasswordUrl: "dsd",
    forgotPassword: true,
    title: "DynaMed Shared Decisions",
    header: { logo: { src: dcdLogo, alt: "DynaMed Shared Decisions" } },
    footer: {
      links: [
        { url: "https://www.ebsco.com/health-care/products/dynamed-shared-decisions", text: "About DynaMed Shared Decisions" },
        { url: "https://connect.ebsco.com/", text: "Help" },
        { url: feedbackLink, text: "Feedback" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
        { url: "", text: manageCookiesText, cookiesLink: true },
      ],
    },
    groupLogin: false,
  },
  "dynamed.shared.decisions-mobile-client": {
    theme: "dsd",
    productName: "dsd",
    isMobile: true,
    resetPasswordUrl: "dsd",
    forgotPassword: true,
    forgotPasswordReturnUrl: "https://decisions.dynamed.com/",
    title: "Sign in to DynaMed Shared Decisions",
    header: { logo: { src: dcdLogo, alt: "DynaMed Shared Decisions" } },
    footer: {
      links: [
        { url: "https://www.ebsco.com/health-care/products/dynamed-shared-decisions", text: "About DynaMed Shared Decisions" },
        { url: "https://connect.ebsco.com/", text: "Help" },
        { url: feedbackLink, text: "Feedback" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
      ],
    },
    groupLogin: true,
  },
  "myhealthdecisions": {
    theme: "dsd",
    productName: "dsd",
    isMobile: false,
    resetPasswordUrl: "dsd",
    forgotPassword: true,
    title: "My Health Decisions",
    header: { logo: { src: dsdLogo, alt: "My Health Decisions" } },
    footer: {
      links: [
        { url: "https://www.ebsco.com/health-care/products/my-health-decisions", text: "About My Health Decisions" },
        { url: "https://connect.ebsco.com/", text: "Help" },
        { url: feedbackLink, text: "Feedback" },
        { url: privacyPolicyLink, text: "Privacy Policy" },
        { url: termsOfUseLink, text: "Terms of Use" },
        { url: copyrightLink, text: "Copyright" },
        { url: "", text: manageCookiesText, cookiesLink: true },
      ],
    },
    groupLogin: false,
  }
};
